module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"all":"All","range":{"over":"Above {value} {unit}","under":"Below {value} {unit}","between":"{start} - {end} {unit}"}}}')
  delete Component.options._Ctor
}
